// extracted by mini-css-extract-plugin
export default {"img":"img","svg":"svg","non_svg":"non_svg","qr":"qr"};